"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const alertOptionsHoverValue = (state = '', action) => {
    if (action.type === 'SET_HOVER_OPTION') {
        return action.hover;
    }
    return state;
};
const isAlertOptionsOpen = (state = '', action) => {
    switch (action.type) {
        case 'SET_ALERT_OPTIONS_MODAL_OPEN':
        case 'SET_ALERT_OPTIONS_MODAL_CLOSING':
        case 'SET_ALERT_OPTIONS_MODAL_CLOSED':
            return action.deviceInfoSelected;
        default:
            return state;
    }
};
const isTapBehaviorSelectorOpen = (state = 'close', action) => {
    switch (action.type) {
        case 'OPEN_TAP_BEHAVIOR_SELECTOR':
            return 'open';
        case 'CLOSE_TAP_BEHAVIOR_SELECTOR':
            return 'close';
        case 'CLOSING_TAP_BEHAVIOR_SELECTOR':
            return 'closing';
        default:
            return state;
    }
};
exports.default = redux_1.combineReducers({
    alertOptionsHoverValue,
    isAlertOptionsOpen,
    isTapBehaviorSelectorOpen,
});
exports.getAlertOptionHoverValue = (state) => state.alertOptionsHoverValue;
exports.getIsAlertOptionsOpen = (state) => state.isAlertOptionsOpen;
exports.getIsTapBehaviorSelectorOpen = (state) => state.isTapBehaviorSelectorOpen;
